import React, { useEffect, Fragment, useState } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";
import { DfpComponent } from "../../../ads/dfp-component";
import SearchEntity from "../search-entity/search";
import { ProfileImage } from "../profile-image";
import TrendingStories from "../trending-stories";

import "./companies.m.css";

export function EntityPageCompanies({ data = {}, config = {} }) {
  const sketchesHost = config["sketches-host"];
  const networkId = useSelector((state) => get(state, ["qt", "config", "ads-config", "network_id"], ""));
  const currPath = useSelector((state) => get(state, ["qt", "currentPath"], ""))
    .split("?")[0]
    .split("/")[1];
  const pageName = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_name_mapping", currPath], "sections")
  );
  const midAdUnit = `/${networkId}/GULFNEWS/Gulfnews_Mid/gulfnews_${pageName}_mid/gulfnews_${pageName}_mid_1`;
  const midAdUnit2 = `/${networkId}/GULFNEWS/Gulfnews_Mid/gulfnews_${pageName}_mid/gulfnews_${pageName}_mid_2`;
  const adConfig = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "section_page_adslot_3"], {})
  );
  const BottomAdUnit = `/${networkId}/GULFNEWS/Gulfnews_BTF/gulfnews_${pageName}_btf/gulfnews_${pageName}_btf_footer`;
  const adConfig1 = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "section_page_adslot_3"], {})
  );
  let placeData = get(data, ["data", "entities"], []);
  placeData = placeData.sort((a, b) => Number(a.sequence || 200) - Number(b.sequence || 200));
  const [showLoadmore, setShowLoadmore] = useState(false);
  const limit = 16;
  const [offset, setOffset] = useState(limit);
  const [items, setItems] = useState(placeData?.length > limit ? placeData.slice(0, limit) : placeData);
  const entityName = "company";

  const getLoadMorePlaces = async () => {
    const newItems = placeData.slice(offset, limit + offset);
    setItems([...items, ...newItems]);
    setOffset((prevOffset) => prevOffset + limit);
  };

  const handleLoadMore = async () => {
    await getLoadMorePlaces();
  };

  useEffect(() => {
    items?.length >= offset ? setShowLoadmore(true) : setShowLoadmore(false);
  }, [offset]);

  return (
    <div styleName="entity-companies-container">
      <div styleName="top-banner">
        <img src="https://images.assettype.com/gulfnews/2025-09-25/8fipm1yo/companies-desktop.png" />
      </div>
      <div styleName="top-banner-mobile">
        <img src="https://images.assettype.com/gulfnews/2025-09-25/4dvm9bqc/companies-mobile.png" />
      </div>
      <SearchEntity entityName={entityName} onResults={setItems} />
      {items?.length ? (
        <div styleName="entity-list">
          {items.map((item, index) => {
            const profileImg = get(item, ["logo"], []);
            return (
              <Fragment key={index}>
                <div styleName="entity-list-detail">
                  <Link href={`${sketchesHost}/companies/${item?.slug}`}>
                    <ProfileImage imageUrl={profileImg} defaultWidth="90" entityName={entityName} />
                  </Link>
                  <div styleName="info">
                    <Link href={`${sketchesHost}/companies/${item?.slug}`}>
                      <div styleName="name">{item?.name}</div>
                    </Link>
                    <div styleName="bio">{item?.tagline}</div>
                    <div styleName="details">
                      <Link href={`${sketchesHost}/companies/${item?.slug}`}>View Profile</Link>
                    </div>
                  </div>
                </div>
                {index === 21 && (
                  <div styleName="ad-slot-970x250-wrapper">
                    <DfpComponent
                      adStyleName={"ad-slot-size-970x250"}
                      id="entity-page-ad"
                      path={midAdUnit}
                      size={adConfig.sizes}
                      viewPortSizeMapping={adConfig.view_port_size_mapping}
                    />
                  </div>
                )}
              </Fragment>
            );
          })}
        </div>
      ) : (
        <div styleName="entity-list no-result">No result found.</div>
      )}
      {showLoadmore && <div styleName="load-more">{<button onClick={handleLoadMore}>LOAD MORE</button>}</div>}
      <div styleName="bottom-ad-container">
        <DfpComponent
          adStyleName={"ad-slot-size-970x250"}
          id="entity-page-ad-2"
          path={midAdUnit2}
          size={adConfig.sizes}
          viewPortSizeMapping={adConfig.view_port_size_mapping}
        />
      </div>
      <TrendingStories />
      <div styleName="bottom-ad-container">
        <DfpComponent
          adStyleName="ad-slot-size-970x250"
          id={`places-bottom-ad`}
          path={BottomAdUnit}
          size={adConfig1.sizes}
          viewPortSizeMapping={adConfig1.view_port_size_mapping}
        />
      </div>
    </div>
  );
}
